
import { isEmpty } from 'lodash';

export default {
  name: 'ABreadcrumbs',
  props: {
    navigation: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isEmpty,
  },
};
